export class LogSourceLocation {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudTrail",
            "baseName": "cloudTrail",
            "type": "LogSourceLocationCloudTrail",
            "format": ""
        },
        {
            "name": "datadog",
            "baseName": "datadog",
            "type": "LogSourceLocationDatadog",
            "format": ""
        },
        {
            "name": "cloudWatchLogs",
            "baseName": "cloudWatchLogs",
            "type": "LogSourceLocationCloudWatchLogs",
            "format": ""
        },
        {
            "name": "splunkDdss",
            "baseName": "splunkDdss",
            "type": "LogSourceLocationSplunkDdss",
            "format": ""
        },
        {
            "name": "gcpCloudLogging",
            "baseName": "gcpCloudLogging",
            "type": "LogSourceLocationGcpCloudLogging",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LogSourceLocation.attributeTypeMap;
    }
    constructor() {
    }
}
